import React from "react";
import { useTranslation } from "react-i18next";
import { usePopup } from "@/context/PopupContext";
import styles from "./OpenMenuBlock.module.scss";

const OpenMenuBlock: React.FC = () => {
  const { t } = useTranslation("common");
  const { openMenu } = usePopup();

  return (
    <div className="container">
      <div className={`${styles.openMenuBlock} sideP88`}>
        <div className={styles.textContent}>
          <h2>{t("cta.title")}</h2>
          <p>{t("cta.description")}</p>
        </div>
        <button
          className={`${styles.button} commonButton buttonXl`}
          onClick={openMenu}
        >
          {t("cta.button")}
        </button>
        <img
          className={styles.bgImg}
          src="/images/deco-bg.svg"
          alt=""
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default OpenMenuBlock;
